import { render, staticRenderFns } from "./GlobalCountNotif.vue?vue&type=template&id=72ec8210"
import script from "./GlobalCountNotif.vue?vue&type=script&lang=js"
export * from "./GlobalCountNotif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports